/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseDiningTableDto } from '../models/api-response-dining-table-dto';
import { ApiResponseListDiningTableDto } from '../models/api-response-list-dining-table-dto';
import { bulkCreateDiningTables } from '../fn/dining-table-api/bulk-create-dining-tables';
import { BulkCreateDiningTables$Params } from '../fn/dining-table-api/bulk-create-dining-tables';
import { createDiningTable } from '../fn/dining-table-api/create-dining-table';
import { CreateDiningTable$Params } from '../fn/dining-table-api/create-dining-table';
import { deleteDiningTable } from '../fn/dining-table-api/delete-dining-table';
import { DeleteDiningTable$Params } from '../fn/dining-table-api/delete-dining-table';
import { listDiningTables } from '../fn/dining-table-api/list-dining-tables';
import { ListDiningTables$Params } from '../fn/dining-table-api/list-dining-tables';
import { regenerateDiningTableQr } from '../fn/dining-table-api/regenerate-dining-table-qr';
import { RegenerateDiningTableQr$Params } from '../fn/dining-table-api/regenerate-dining-table-qr';
import { updateDiningTable } from '../fn/dining-table-api/update-dining-table';
import { UpdateDiningTable$Params } from '../fn/dining-table-api/update-dining-table';

@Injectable({ providedIn: 'root' })
export class DiningTableApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listDiningTables()` */
  static readonly ListDiningTablesPath = '/v1/api/dining-tables/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listDiningTables()` instead.
   *
   * This method doesn't expect any request body.
   */
  listDiningTables$Response(params: ListDiningTables$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListDiningTableDto>> {
    return listDiningTables(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listDiningTables$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listDiningTables(params: ListDiningTables$Params, context?: HttpContext): Observable<ApiResponseListDiningTableDto> {
    return this.listDiningTables$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListDiningTableDto>): ApiResponseListDiningTableDto => r.body)
    );
  }

  /** Path part for operation `createDiningTable()` */
  static readonly CreateDiningTablePath = '/v1/api/dining-tables/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDiningTable()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDiningTable$Response(params: CreateDiningTable$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDiningTableDto>> {
    return createDiningTable(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createDiningTable$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDiningTable(params: CreateDiningTable$Params, context?: HttpContext): Observable<ApiResponseDiningTableDto> {
    return this.createDiningTable$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseDiningTableDto>): ApiResponseDiningTableDto => r.body)
    );
  }

  /** Path part for operation `bulkCreateDiningTables()` */
  static readonly BulkCreateDiningTablesPath = '/v1/api/dining-tables/bulk-create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkCreateDiningTables()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkCreateDiningTables$Response(params: BulkCreateDiningTables$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListDiningTableDto>> {
    return bulkCreateDiningTables(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bulkCreateDiningTables$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkCreateDiningTables(params: BulkCreateDiningTables$Params, context?: HttpContext): Observable<ApiResponseListDiningTableDto> {
    return this.bulkCreateDiningTables$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListDiningTableDto>): ApiResponseListDiningTableDto => r.body)
    );
  }

  /** Path part for operation `updateDiningTable()` */
  static readonly UpdateDiningTablePath = '/v1/api/dining-tables/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDiningTable()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDiningTable$Response(params: UpdateDiningTable$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDiningTableDto>> {
    return updateDiningTable(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDiningTable$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDiningTable(params: UpdateDiningTable$Params, context?: HttpContext): Observable<ApiResponseDiningTableDto> {
    return this.updateDiningTable$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseDiningTableDto>): ApiResponseDiningTableDto => r.body)
    );
  }

  /** Path part for operation `deleteDiningTable()` */
  static readonly DeleteDiningTablePath = '/v1/api/dining-tables/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDiningTable()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDiningTable$Response(params: DeleteDiningTable$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteDiningTable(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteDiningTable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDiningTable(params: DeleteDiningTable$Params, context?: HttpContext): Observable<void> {
    return this.deleteDiningTable$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `regenerateDiningTableQr()` */
  static readonly RegenerateDiningTableQrPath = '/v1/api/dining-tables/{reference}/regenerate-qr';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `regenerateDiningTableQr()` instead.
   *
   * This method doesn't expect any request body.
   */
  regenerateDiningTableQr$Response(params: RegenerateDiningTableQr$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDiningTableDto>> {
    return regenerateDiningTableQr(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `regenerateDiningTableQr$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  regenerateDiningTableQr(params: RegenerateDiningTableQr$Params, context?: HttpContext): Observable<ApiResponseDiningTableDto> {
    return this.regenerateDiningTableQr$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseDiningTableDto>): ApiResponseDiningTableDto => r.body)
    );
  }

}
